import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { API } from "../../lib/api";

const TYPES = [
  { v: "table", l: "Masa" }, { v: "lounger", l: "Şezlong" }, { v: "bar", l: "Bar" },
  { v: "cabana", l: "Cabana" }, { v: "vip", l: "VIP" }, { v: "general", l: "Genel" },
];

const QRAreas = () => {
  const [list, setList] = useState([]);
  const [form, setForm] = useState({ areaType: "table", areaName: "", areaNumber: "", isActive: true });

  const load = () => api.get("/qr-areas").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    if (!form.areaName) return;
    await api.post("/qr-areas", form);
    toast.success("Eklendi"); setForm({ areaType: "table", areaName: "", areaNumber: "", isActive: true }); load();
  };

  const toggle = async (a) => {
    await api.put(`/qr-areas/${a.id}`, { ...a, isActive: !a.isActive });
    load();
  };

  const del = async (id) => {
    if (!window.confirm("Silinsin mi?")) return;
    await api.delete(`/qr-areas/${id}`); load();
  };

  const downloadQr = async (a) => {
    const token = localStorage.getItem("zbeach_token");
    const base = window.location.origin;
    try {
      const res = await fetch(`${API}/qr-areas/${a.id}/png?base_url=${encodeURIComponent(base)}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error();
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `zbeach-${a.areaName.replace(/\s/g, "-")}.png`;
      link.click();
      URL.revokeObjectURL(url);
    } catch {
      toast.error("QR oluşturulamadı");
    }
  };

  return (
    <div className="space-y-6" data-testid="qr-areas-page">
      <header>
        <h1 className="font-serif text-3xl text-zbeach-dark">QR Alanları</h1>
        <p className="text-zbeach-muted text-sm mt-1">Masa, şezlong, cabana ve diğer alanlar için QR kodlar oluşturun.</p>
      </header>

      <form onSubmit={create} className="bg-zbeach-surface border border-zbeach-gold/15 rounded-2xl p-4 grid grid-cols-1 md:grid-cols-5 gap-3 items-end" data-testid="qr-area-form">
        <div>
          <label className="block text-xs uppercase tracking-wider text-zbeach-muted mb-1">Tip</label>
          <select value={form.areaType} onChange={(e) => setForm({ ...form, areaType: e.target.value })} className="w-full px-3 py-2 rounded-lg bg-zbeach-bg border border-zbeach-gold/20 text-sm">
            {TYPES.map((t) => <option key={t.v} value={t.v}>{t.l}</option>)}
          </select>
        </div>
        <div>
          <label className="block text-xs uppercase tracking-wider text-zbeach-muted mb-1">Alan Adı</label>
          <input value={form.areaName} onChange={(e) => setForm({ ...form, areaName: e.target.value })} placeholder="Masa 1" required className="w-full px-3 py-2 rounded-lg bg-zbeach-bg border border-zbeach-gold/20 text-sm" data-testid="qr-area-name" />
        </div>
        <div>
          <label className="block text-xs uppercase tracking-wider text-zbeach-muted mb-1">Numara</label>
          <input value={form.areaNumber} onChange={(e) => setForm({ ...form, areaNumber: e.target.value })} placeholder="1" className="w-full px-3 py-2 rounded-lg bg-zbeach-bg border border-zbeach-gold/20 text-sm" />
        </div>
        <button type="submit" className="px-4 py-2.5 rounded-full bg-zbeach-turquoise text-white font-medium text-sm md:col-span-2" data-testid="qr-area-create">
          <i className="fa-solid fa-plus mr-1" /> Alan Ekle
        </button>
      </form>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {list.map((a) => (
          <div key={a.id} className="bg-zbeach-surface border border-zbeach-gold/15 rounded-2xl p-4" data-testid={`qr-area-${a.id}`}>
            <div className="flex items-start justify-between">
              <div>
                <div className="text-[11px] uppercase tracking-wider text-zbeach-gold font-medium">{TYPES.find((t) => t.v === a.areaType)?.l}</div>
                <div className="font-serif text-xl text-zbeach-dark mt-1">{a.areaName}</div>
                <div className="text-xs text-zbeach-muted mt-1 truncate">{a.qrUrl}</div>
              </div>
              <button onClick={() => toggle(a)} className="text-xs">
                {a.isActive ? <span className="px-2 py-0.5 rounded-full bg-green-100 text-green-700">Aktif</span> : <span className="px-2 py-0.5 rounded-full bg-zbeach-muted/15 text-zbeach-muted">Pasif</span>}
              </button>
            </div>
            <div className="flex gap-2 mt-3">
              <button onClick={() => downloadQr(a)} className="flex-1 py-2 rounded-full bg-zbeach-turquoise text-white text-xs font-medium" data-testid={`qr-download-${a.id}`}><i className="fa-solid fa-download mr-1" /> QR İndir</button>
              <button onClick={() => del(a.id)} className="px-3 py-2 rounded-full bg-red-50 text-red-600 text-xs"><i className="fa-solid fa-trash" /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QRAreas;
